import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getTenantStatus, getAvailableTenants, getTenantUrl } from '../services/api';
import './Login.css';

/**
 * Shown when the user has a tenant subdomain (or ?tenant=) but that tenant does not exist in the backend DB.
 * Blocks access until they use a valid tenant URL.
 */
function InvalidTenantPage() {
  const { t } = useTranslation('auth');
  const [tenantStatus, setTenantStatus] = useState(null);
  const [availableTenants, setAvailableTenants] = useState([]);
  useEffect(() => {
    getTenantStatus().then(setTenantStatus);
    getAvailableTenants().then(setAvailableTenants);
  }, []);
  const currentTenant = tenantStatus?.subdomain ?? null;
  const isInactiveOrArchived = tenantStatus?.reason === 'inactive_or_archived';
  return (
    <div className="auth-container" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem' }}>
      <div className="auth-card" style={{ maxWidth: '480px', textAlign: 'center' }}>
        <h1 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary, #1a1a1a)' }}>
          {t('invalidTenantTitle')}
        </h1>
        <p style={{ marginBottom: '1rem', fontSize: '0.875rem', color: 'var(--text-muted, #888)' }}>
          {t('currentTenant')} <small>{t('fromBackend')}</small>{' '}
          <strong style={{ color: 'var(--text-secondary, #555)' }}>
            {currentTenant === null ? '...' : (currentTenant || t('none'))}
          </strong>
        </p>
        <p style={{ marginBottom: '1rem', color: 'var(--text-secondary, #555)', lineHeight: 1.6 }}>
          {isInactiveOrArchived
            ? t('invalidTenantInactiveBody')
            : t('invalidTenantMissingBody')}
        </p>
        {availableTenants.length > 0 && (
          <div style={{ marginBottom: '1.5rem', textAlign: 'left' }}>
            <strong style={{ fontSize: '0.875rem', color: 'var(--text-secondary, #555)' }}>{t('availableTenants')}</strong>
            <ul style={{ marginTop: '0.5rem', paddingLeft: '1.25rem', fontSize: '0.875rem', color: 'var(--text-secondary, #555)' }}>
              {availableTenants.map((tenant) => (
                <li key={tenant.subdomain}>
                  <a
                    href={getTenantUrl(tenant.subdomain)}
                    style={{ color: 'var(--primary, #2563eb)', textDecoration: 'none' }}
                  >
                    {tenant.name || tenant.subdomain} ({tenant.subdomain})
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
        <p style={{ fontSize: '0.95rem', color: 'var(--text-muted, #888)' }}>
          {t('invalidTenantFooter')}
        </p>
      </div>
    </div>
  );
}

export default InvalidTenantPage;
